import { driverCommands,driverRecoveryPrefix,type DriverAccount } from './client.ts';
import type { DriverTarget } from './contract.ts';
import type { RecoveryStorage } from '../browser-recovery/storage.ts';
type Entry={client:ReturnType<typeof driverCommands>;current:()=>boolean};
export function driverCommandCache(){
 const entries=new Map<string,Entry>();
 return {
  get(base:string,account:DriverAccount,target:DriverTarget,current:()=>boolean,begin?:()=>()=>void,storage?:RecoveryStorage){
   const key=driverRecoveryPrefix(base,account,target);let entry=entries.get(key);
   if(!entry){entry={current,client:null as unknown as ReturnType<typeof driverCommands>};const owner=entry;entry.client=driverCommands(base,account,target,storage,()=>owner.current,begin);entries.set(key,entry);}
   entry.current=current;const selected=entry;
   return {client:entry.client,activate:()=>{entries.set(key,selected);selected.current=current;},release:()=>{if(selected.current!==current)return;selected.current=()=>false;const state=selected.client.snapshot();if(!state.pending&&!state.busy&&!state.blocked)entries.delete(key);}};
  },
  refresh:()=>entries.forEach(entry=>entry.client.refreshSaved()),
 };
}
